import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../logo.png';
import GooglePlayButton from './GooglePlayButton';
import AppleButton from './AppleButton';

function Home() {
  const { t } = useTranslation();

  const featureCards = [
    {
      image: '/images/feature-1.png',
      altKey: 'feature_1_alt',
      textKey: 'feature_1_description',
    },
    {
      image: '/images/feature-2.png',
      altKey: 'feature_2_alt',
      textKey: 'feature_2_description',
    },
    {
      image: '/images/feature-3.png',
      altKey: 'feature_3_alt',
      textKey: 'feature_3_description',
    },
    {
      image: '/images/feature-4.png',
      altKey: 'feature_4_alt',
      textKey: 'feature_4_description',
    },
    {
      image: '/images/feature-5.png',
      altKey: 'feature_5_alt',
      textKey: 'feature_5_description',
    },
    {
      image: '/images/feature-6.png',
      altKey: 'feature_6_alt',
      textKey: 'feature_6_description',
    },
  ];

  return (
    <section className="bg-[#5DA271] py-8 flex flex-col items-center">
      <div className="h-16"></div>
<div className="w-full">
    <p className="mb-8 text-center text-white text-lg font-semibold rounded-lg">
      {t("game_description_0")}
    </p>
  </div>
      {/* <div className="mb-8" style={{ width: '672px', height: '384px' }}> */}
     <div className="mb-8 w-10/12 md:w-1/2 lg:w-1/3">
  <img
    src={logo}
    alt="Logo"
    className="mx-auto h-auto"
  />
</div>

<div className="w-full">
    <p className="mb-2 text-center text-white text-lg font-semibold rounded-lg">
      {t("game_description_1")}
    </p>
     <p className="mb-2 text-center text-white text-lg font-semibold rounded-lg">
      {t("game_description_2")}
    </p>
    <p className="mb-8 text-center text-white text-lg font-semibold rounded-lg">
      {t("game_description_3")}
    </p>
  </div>
      <div className="h-4"></div>
{/* Divider + PLAY NOW */}
      <div className="w-full max-w-2xl mx-auto px-4">
        <div className="w-full border-t border-white/70 mb-3" />
        <p className="mt-2 text-center text-2xl md:text-4xl text-white font-extrabold tracking-wide">
          {t('play_now')}
        </p>
      </div>
      <div className="h-8"></div>
      
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 px-4 w-full md:w-1/2">
        <div className="flex justify-center">
          <GooglePlayButton />
        </div>
        <div className="flex justify-center">
          <AppleButton />
        </div>
      </div>

      <div className="h-4"></div>

       {/* Divider + WHY YOU WILL LOVE IT */}
      <div className="w-full max-w-2xl mx-auto px-4 mb-4">
        <div className="w-full border-t border-white/70 mb-3" />
        <p className="mt-8 text-center text-xl md:text-2xl text-white font-bold tracking-wide">
          {t('why_you_will_love_it')}
        </p>
      </div>

      {/* 2 rows x 3 columns: vertical image + text */}
      <div className="mx-auto w-full md:w-2/3 px-4 mt-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {featureCards.map((feature) => (
           <div key={feature.textKey}>
  <div className="w-full">
    <img
      src={feature.image}
      alt={t(feature.altKey)}
      className="w-3/4 sm:w-full h-full object-cover mx-auto"
    />
  </div>
  <div className="w-full">
    <p className="m-4 text-center text-white text-lg font-semibold px-4 py-3 rounded-lg">
      {t(feature.textKey)}
    </p>
  </div>
  <div className="h-8"></div>
</div>
          ))}
        </div>
      </div>
      
      {/* Multilanguage box */}
      <div className="">
        <div className="p-6 rounded-lg col-span-3 grid grid-cols-1 md:col-start-2 md:col-span-3">
          <div className="flex flex-col items-center justify-center space-y-4">
            <h3 className="text-xl text-white text-lg font-bold">{t('multilanguage')}</h3>
            <p className="text-center text-white text-lg font-semibold px-4 py-3 rounded-lg">
              {t('multilanguage_description')}
            </p>
            <div className="flex justify-center items-center w-full">
              <img
                src="/images/multilingua.png"
                alt="Card 1"
                className="w-full md:w-1/2 h-auto rounded-lg m-2"
              />
            </div>
          </div>
        </div>
      </div>

 {/* Divider + ENJOY TEXT */}
      <div className="w-full max-w-2xl mx-auto px-4 mt-4">
        <div className="w-full border-t border-white/70 mb-3" />
        <p className="mt-2 text-center text-2xl md:text-3xl text-white font-bold tracking-wide">
          {t('enjoy_text')}
        </p>
      </div>


      <div className="h-16"></div>
    </section>
  );
}

export default Home;
